module.exports = __webpack_public_path__ + "img/oneday1-2.23827320.jpg";